class PincodeChecker extends HTMLElement {
  constructor() {
    super();
    this.pincodeInput = this.querySelector('#pincode-input') || this.querySelector('.pincode-checker__input');
    this.checkButton = this.querySelector('#check-button') || this.querySelector('.pincode-checker__button');
    this.resultContainer = this.querySelector('#delivery-result') || this.querySelector('.pincode-checker__result');
    this.validPincodes = [];
    this.isLoading = false;
  }

  connectedCallback() {
    this.loadPincodes();
    this.checkButton.addEventListener('click', this.checkPincode.bind(this));
    this.pincodeInput.addEventListener('keypress', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.checkPincode();
      }
    });
  }

  loadPincodes() {
    const pincodesString = this.dataset.pincodes || '';
    if (pincodesString) {
      // Split by commas and trim whitespace
      this.validPincodes = pincodesString.split(',').map(code => code.trim());
    }
  }

  checkPincode() {
    const pincode = this.pincodeInput.value.trim();
    
    if (!pincode) {
      // Use configurable empty pincode error message if available
      const emptyPincodeMessage = this.dataset.emptyPincodeMessage || 'Please enter a pincode';
      this.showError(emptyPincodeMessage);
      return;
    }

    this.setLoading(true);

    // Simulate a small delay for better UX
    setTimeout(() => {
      if (this.validPincodes.includes(pincode)) {
        this.showSuccess(pincode);
      } else {
        // Use configurable invalid pincode error message if available
        const invalidPincodeMessage = this.dataset.invalidPincodeMessage || 'Sorry, delivery is not available for this pincode';
        this.showError(invalidPincodeMessage);
      }
      this.setLoading(false);
    }, 500);
  }

  setLoading(isLoading) {
    this.isLoading = isLoading;
    if (isLoading) {
      this.checkButton.classList.add('loading');
      this.checkButton.setAttribute('disabled', 'disabled');
    } else {
      this.checkButton.classList.remove('loading');
      this.checkButton.removeAttribute('disabled');
    }
  }

  showSuccess(pincode) {
    // Calculate delivery dates
    const today = new Date();
    const minDays = 3;
    const maxDays = 5;
    
    const minDeliveryDate = new Date(today);
    minDeliveryDate.setDate(today.getDate() + minDays);
    
    const maxDeliveryDate = new Date(today);
    maxDeliveryDate.setDate(today.getDate() + maxDays);
    
    // Format dates
    const options = { weekday: 'short', day: 'numeric', month: 'short' };
    const minDateFormatted = minDeliveryDate.toLocaleDateString('en-US', options);
    const maxDateFormatted = maxDeliveryDate.toLocaleDateString('en-US', options);

    // Use configurable success message if available
    const successMessage = this.dataset.successMessage || 'Delivery available at';
    const deliveryEstimateMessage = this.dataset.deliveryEstimateMessage || 'Estimated delivery:';
	const deliveryAvailableMessage = this.dataset.deliveryAvailableMessage || 'Shipping Available in';

    this.resultContainer.innerHTML = `
      <div class="delivery-success">
        <p>${successMessage} ${pincode}</p>
        <p>${deliveryEstimateMessage} ${minDateFormatted} - ${maxDateFormatted}</p>
		<p>${deliveryAvailableMessage} 1-3 days</p>
      </div>
    `;
  }

  showError(message) {
    // Use configurable error message if available
    const errorMessage = this.dataset.errorMessage || message;
    
    this.resultContainer.innerHTML = `
      <div class="delivery-error">
        <p>${errorMessage}</p>
      </div>
    `;
  }
}

customElements.define('pincode-checker', PincodeChecker);